var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShippingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5714 3.46863H7.4285C6.79732 3.46863 6.28564 3.9803 6.28564 4.61149V9.75434C6.28564 10.3855 6.79732 10.8972 7.4285 10.8972H12.5714C13.2025 10.8972 13.7142 10.3855 13.7142 9.75434V4.61149C13.7142 3.9803 13.2025 3.46863 12.5714 3.46863Z",
    stroke: "currentColor",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57153 13.7543H13.2687C13.5685 13.7555 13.8558 13.8746 14.0687 14.0857L15.4287 15.4686",
    stroke: "currentColor",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.571533 0.61145H1.71439C2.01749 0.61145 2.30819 0.731858 2.52251 0.946185C2.73684 1.16051 2.85725 1.4512 2.85725 1.75431V11.4686",
    stroke: "currentColor",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57137 13.4686C4.57702 13.5638 4.57702 13.6592 4.57137 13.7544C4.53437 14.2681 4.29951 14.7474 3.91624 15.0914C3.53296 15.4354 3.03116 15.6173 2.51646 15.5988C2.00177 15.5803 1.51433 15.3628 1.15676 14.9921C0.799183 14.6215 0.599365 14.1265 0.599365 13.6115C0.599365 13.0965 0.799183 12.6015 1.15676 12.2309C1.51433 11.8602 2.00177 11.6427 2.51646 11.6242C3.03116 11.6057 3.53296 11.7876 3.91624 12.1316C4.29951 12.4756 4.53437 12.9549 4.57137 13.4686V13.4686Z",
    stroke: "currentColor",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71436 8.04004H10.8572",
    stroke: "currentColor",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingCart);
export default __webpack_public_path__ + "static/media/shipping-cart.f3de4bd51ffd227da06d0c1b3085d3d1.svg";
export { ForwardRef as ReactComponent };